import { defineStore } from "pinia";
import type { WebModelGetMajorMinorFirmwareVersion } from "~/model/api/pLCnextStoreFrontendAPI.schemas";
import {
  createMajorMinorVersion,
  findAllMajorMinorVersions,
} from "~/model/api/pLCnextStoreFrontendAPI";
import { withErrorHandling } from "~/helpers/withErrorHandling";
import { withErrorMessage } from "~/helpers/withErrorMessage";
import { withLoading } from "~/helpers/withLoading";
import type { TypeOption } from "~/stores/ui/specific/appsfilterstore";
import { sortBy } from "~/helpers/sortBy";

interface State {
  majorMinorFirmwareVersions: WebModelGetMajorMinorFirmwareVersion[];
}

export const useFirmwareVersionsStore = defineStore("firmwareVersions", {
  // convert to a function
  state: (): State => ({
    majorMinorFirmwareVersions: [], // initial state
  }),
  getters: {
    getMajorMinorFirmwareVersionsAsTypeOptions: (state) => {
      const typeOptions: TypeOption[] = [];
      const sortedMajorMinor = state.majorMinorFirmwareVersions.toSorted(
        sortBy({ key: "major", order: "asc" }, { key: "minor", order: "asc" }),
      );
      for (const element of sortedMajorMinor) {
        if (element.id && element.major && element.minor) {
          typeOptions.push({
            value: "" + element.id,
            text: "20" + element.major + "." + element.minor,
          });
        }
      }
      return typeOptions;
    },
    getMajorMinorFirmwareVersionForId: (state) => (id: number) => {
      return state.majorMinorFirmwareVersions.find(
        (version) => version.id === id,
      );
    },
  },
  actions: {
    async getAllMajorMinorFirmwareVersions() {
      const { data, error } = await withErrorHandling(
        withErrorMessage(withLoading(findAllMajorMinorVersions())),
      );
      console.debug("getAllMajorMinorFirmwareVersions: ", data, error);
      if (data) {
        this.majorMinorFirmwareVersions = data;
      }
    },

    // admin only
    async addMajorMinorFirmwareVersion(major: number, minor: number) {
      const { data } = await withErrorMessage(
        withLoading(createMajorMinorVersion({ major, minor })),
      );
      console.debug("addMajorMinorFirmwareVersion: ", data);
      if (data) {
        await this.getAllMajorMinorFirmwareVersions();
      }
    },

    // easily reset state using `$reset`
    clear() {
      this.$reset();
    },
  },
});
